module.exports = __webpack_public_path__ + "img/backbutton.fb47c404.png";